import * as v from 'valibot'

/** Opaque server/database identity isolates local recovery after an API data-domain switch. */
export const NovelAuthoringContext = v.strictObject({
  data_domain: v.pipe(v.string(), v.minLength(1)),
  account_id: v.pipe(v.string(), v.minLength(1)),
  server_version: v.pipe(v.string(), v.minLength(1)),
})
